//@flow
import {
  STORE_ERROR,
  STORE_TOKEN,
  REQUEST_LOGIN,
  OPEN_LOGIN_MODAL,
  OPEN_SIGNUP_MODAL,
  CLEAR_ALL_ERRORS,
  CLOSE_LOGIN_MODAL,
  REGISTER_ACCOUNT,
  STORE_USER_INFORMATION,
  LOGIN_SESSION_EXPIRE,
  RESET_USER_DATA,
  STORE_INVOICES,
} from '../actions/types';
import type { Action } from '../../types/action';

type State = {
  error: ?string,
  isFetching: boolean,
  role: ?string,
  id: ?string,
  userId: ?string,
  isModalOpen?: boolean,
  isLeader: boolean,
  name: string,
  connectedLodge: Array<string>,
  primaryImage?: string | null,
  profileImages?: string | null,
  invoices: null | Array<Object>,
};

const initialState = {
  error: '',
  isFetching: false,
  role: '',
  id: '',
  isLeader: false,
  userId: null,
  isModalOpen: false,
  isSignUpOpen: false,
  hasSessionExpired: false,
  name: '',
  connectedLodge: [],
  primaryImage: '',
  profileImages: '',
  invoices: null,
  token: '',
  email: '',
};

export default (state: State = initialState, action: Action): State => {
  const {
    userRole,
    error,
    userId,
    name,
    primaryImage,
    profileImages,
    connectedLodge,
    id,
    isLeader,
    sessionState,
    invoices,
    token,
    email,
    avatar,
  } = action;

  switch (action.type) {
    case OPEN_LOGIN_MODAL:
      return { ...state, isModalOpen: true, isSignUpOpen: false };

    case OPEN_SIGNUP_MODAL:
      return { ...state, isModalOpen: true, isSignUpOpen: true };

    case STORE_TOKEN:
      return {
        ...state,
        error: '',
        isFetching: false,
        role: userRole,
        id,
        token,
      };

    case STORE_USER_INFORMATION:
      return {
        ...state,
        name,
        primaryImage,
        profileImages,
        connectedLodge,
        userId,
        isLeader,
        email,
        avatar,
      };

    case REQUEST_LOGIN:
    case REGISTER_ACCOUNT:
      return { ...state, isFetching: true };

    case STORE_ERROR:
      return { ...state, error, isFetching: false };

    case CLEAR_ALL_ERRORS:
      return { ...state, error: '' };

    case CLOSE_LOGIN_MODAL:
      return { ...state, isModalOpen: false };

    case LOGIN_SESSION_EXPIRE:
      return { ...state, hasSessionExpired: sessionState };
    case STORE_INVOICES:
      return {
        ...state,
        invoices,
      };
    case RESET_USER_DATA:
      return initialState;
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/redux/reducers/authReducer.js